
import { i18nText } from '@/locales';
import { RouterNameEnum } from "@/router/router.types";
import { RouterProperties } from "@/router/routerProperties";
export const FinanceRoutes = [
    {
        path: "/finance",
        redirect: "/finance/acc_cashbox",
        component: (): any => import("@/UI/layouts/MainLayout.vue"),
        meta: {
            alias: RouterNameEnum.AccountsAndCashboxes,
            auth: true,
        },
        children: [
            {
                path: "acc_cashbox/:Studio",
                meta: {
                    alias: RouterNameEnum.AccountsAndCashboxes,
                    title: i18nText("Финансы | Счета и кассы - EPILIER"),
                    breadcrumb: [{ name: i18nText("Счета и кассы"), support: ["studioselect"] }],
                },
                props: { source: "cashbox" },
                name: RouterNameEnum.AccountsAndCashboxes,
                component: (): any => import("@/UI/pages/finance/pages/AccountsAndCashboxes.vue"),
            },
            {
                path: "counterparties",
                meta: {
                    alias: RouterNameEnum.Counterparties,
                    title: i18nText("Финансы | Контрагенты - EPILIER"),
                    breadcrumb: [{ name: i18nText("Контрагенты"), support: ["studioselect"] }],
                    props: {
                        source: {
                            root: "counterparties",
                            name: "counterparties",
                            items: "counterparties",
                            item: "counterparty",
                            routePage: RouterNameEnum.CounterpartiesPage,
                        },
                    },
                },
                name: RouterNameEnum.Counterparties,
                component: (): any => import("@/UI/pages/finance/pages/Counterparties.vue"),
            },
            {
                path: "counterparties/page/:page/:page_size/:total/:filter",
                meta: {
                    alias: RouterNameEnum.Counterparties,
                    title: i18nText("Финансы | Контрагенты - EPILIER"),
                    breadcrumb: [{ name: i18nText("Контрагенты"), support: ["studioselect"] }],
                    props: {
                        source: {
                            root: "counterparties",
                            name: "counterparties",
                            items: "counterparties",
                            item: "counterparty",
                            routePage: RouterNameEnum.CounterpartiesPage,
                        },
                    },
                },
                name: RouterNameEnum.CounterpartiesPage,
                component: (): any => import("@/UI/pages/finance/pages/Counterparties.vue"),
            },
            {
                path: "payment_articles/:Studio",
                meta: {
                    alias: RouterNameEnum.PaymentArticles,
                    title: i18nText("Финансы | Статьи платежей - EPILIER"),
                    breadcrumb: [{ name: i18nText("Статьи платежей"), support: ["studioselect"] }],
                    props: {
                        source: {
                            root: "paymentArticles",
                            name: "paymentArticles",
                            items: "paymentArticles",
                            item: "item",
                            routePage: RouterNameEnum.PaymentArticlesPage,
                        },
                    },
                },
                name: RouterNameEnum.PaymentArticles,
                component: (): any => import("@/UI/pages/finance/pages/PaymentArticles.vue"),
                //props: { source: 'paymentArticles' },

            },

            {
                path: "payment_articles/:Studio/page/:page/:page_size/:total/:filter",
                meta: {
                    alias: RouterNameEnum.PaymentArticles,
                    title: i18nText("Финансы | Статьи платежей - EPILIER"),
                    breadcrumb: [{ name: i18nText("Статьи платежей"), support: ["studioselect"] }],
                    props: {
                        source: {
                            root: "paymentArticles",
                            name: "paymentArticles",
                            items: "paymentArticles",
                            item: "item",
                            routePage: RouterNameEnum.PaymentArticlesPage,
                        },
                    },
                },
                name: RouterNameEnum.PaymentArticlesPage,
                component: (): any => import("@/UI/pages/finance/pages/PaymentArticles.vue"),
                //props: { source: 'paymentArticles' },

            },
            {
                path: "finance_docs",
                meta: {
                    title: i18nText("Финансы | Документы - EPILIER"),
                    breadcrumb: [{ name: i18nText("Документы"), support: ["studioselect"] }],
                },
                name: RouterNameEnum.FinanceDocuments,
                component: (): any => import("@/UI/pages/finance/pages/FinanceDocuments.vue"),
            },
            {
                path: "finance_operations/:Studio",

                name: RouterNameEnum.FinanceOperations,
                meta: {
                    alias: RouterNameEnum.FinanceOperations,
                    title: i18nText("Финансы | Финансовые операции - EPILIER"),
                    breadcrumb: [{ name: i18nText("Финансовые операции"), support: ["studioselect"] }],
                    props: {
                        source: {
                            root: "financeOperations",
                            name: "financeOperations",
                            items: "items",
                            item: "item",
                            routePage: RouterNameEnum.FinanceOperationsPage,
                        },
                        //source: RouterProperties.financeOperations
                    },
                },

                component: (): any => import("@/UI/pages/finance/pages/Index.vue"),
            },
            {
                path: "finance_operations/:Studio/page/:page/:total/:filter/:sorted",

                meta: {
                    alias: RouterNameEnum.FinanceOperations,
                    title: i18nText("Финансы | Финансовые операции - EPILIER"),
                    breadcrumb: [{ name: i18nText("Финансовые операции"), support: ["studioselect"] }],
                    props: {
                        source: {
                            root: "financeOperations",
                            name: "financeOperations",
                            items: "items",
                            item: "item",
                            routePage: RouterNameEnum.FinanceOperationsPage,
                        },
                        //source: RouterProperties.financeOperations
                    },
                },
                name: RouterNameEnum.FinanceOperationsPage,
                component: (): any => import("@/UI/pages/finance/pages/Index.vue"),
            },
        ],
    },
];
